import { cn } from "@/src/shared/utils/mergeTwClasses";
import { ButtonProps } from "@mui/material";
import clsx from "clsx";
import { ComponentProps, FC } from "react";

interface ButtonLoaderProps extends ComponentProps<"div"> {
    size?: ButtonProps["size"];
}

export const ButtonLoader: FC<ButtonLoaderProps> = ({ className, size, ...rest }) => {
    return (
        <div
            className={cn(
                "animate-spin-infinite rounded-full border-solid border-light-gray border-t-current",
                clsx({
                    "border-r-current border-l-transparent border-b-transparent": true,
                    "h-4 w-4 border-[2px]": true,
                    "h-3 w-3 border-[2px]": size === "medium" || size === "small",
                }),
                className,
            )}
            {...rest}
        />
    );
};
